import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FocusLocation =
    | 'intro'
    | `section ${number}`
    | `section ${number} / step ${number}`
    | `section ${number} / note ${number}`
    | 'completion';

export type FocusType =
    | 'tutorial_title'
    | 'tutorial_description'
    | 'section_title'
    | 'section_description'
    | 'step_content'
    | 'note_content'
    | 'completion_message';

export interface FocusState {
    focusSectionLocation: FocusLocation | null;
    focusSectionType: FocusType | null;
    focusSectionKey: string | null;
}

export interface TBWAICoAuthorState {
    focus: FocusState;
    // Future AI Co-Author related state can be added here
    // suggestions: SuggestionState;
    // generationStatus: GenerationStatus;
}

const initialFocusState: FocusState = {
    focusSectionLocation: null,
    focusSectionType: null,
    focusSectionKey: null,
};

const initialState: TBWAICoAuthorState = {
    focus: initialFocusState,
};

const tbwAICoAuthorSlice = createSlice({
    name: 'tbwAICoAuthor',
    initialState,
    reducers: {
        setFocusSection(
            state,
            action: PayloadAction<{
                type: FocusType | null;
                location: FocusLocation | null;
                sectionKey: string | null;
            }>,
        ) {
            state.focus.focusSectionType = action.payload.type;
            state.focus.focusSectionLocation = action.payload.location;
            state.focus.focusSectionKey = action.payload.sectionKey;
        },
        clearFocus(state) {
            state.focus.focusSectionType = null;
            state.focus.focusSectionLocation = null;
            state.focus.focusSectionKey = null;
        },
    },
});

export const { setFocusSection, clearFocus } = tbwAICoAuthorSlice.actions;
export default tbwAICoAuthorSlice.reducer;
